import { render } from "./TheA01PointNoticeCard.vue?vue&type=template&id=c5f80ba4&scoped=true&ts=true"
import script from "./TheA01PointNoticeCard.vue?vue&type=script&lang=ts"
export * from "./TheA01PointNoticeCard.vue?vue&type=script&lang=ts"

import "./TheA01PointNoticeCard.vue?vue&type=style&index=0&id=c5f80ba4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5f80ba4"]])

export default __exports__